var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aspectration",style:(_vm.style)},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"src":_vm.src},on:{"load":_vm.onLoaded}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08c46c20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageWithLoading.vue
// module id = null
// module chunks = 